import React, {FC, useRef, useState} from "react"
import ReactAudioPlayer, {RHAP_UI} from "react-h5-audio-player"

import {onProgress} from "@irati/wellness/utils"
import {injectIntl, InjectIntl} from "@irati/utils/lang"
import tracking from "@irati-tracking/wellness"
import {WellnessMedia} from "@irati/types"
import playImage from "@irati/ui/images/play_circled.svg"

import {PlayOverlayWrapper, OverlayBg, PlayerWrapper} from "./styled"

import "react-h5-audio-player/lib/styles.css"

interface Props extends InjectIntl {
  media: WellnessMedia
}

const Index: FC<Props> = ({media}) => {
  const [isPlaying, setIsPlaying] = useState<boolean>(false)
  const {src, thumbnail} = media
  const playerRef = useRef(null)
  const isQuarterTracked = useRef(false)
  const isFinishTracked = useRef(false)
  const isMidTracked = useRef(false)
  const isThreeQuartersTracked = useRef(false)

  const onListen = () => {
    const player = playerRef?.current?.audio?.current
    if (player) {
      const currentSeconds = Math.trunc(player.currentTime)
      const totalSeconds = Math.trunc(player.duration)

      onProgress(currentSeconds, totalSeconds, media, isQuarterTracked, isMidTracked, isThreeQuartersTracked, isFinishTracked)
    }
  }

  const onStart = () => {
    setIsPlaying(true)
    // This event gets triggered onStart and onResume
    const player = playerRef?.current?.audio?.current
    const currentSeconds = Math.trunc(player?.currentTime)
    // Checking if it's the start of the track
    if (currentSeconds === 0) {
      // Reset all flags if we restart playback from scratch, so we can track if it gets finished again
      isFinishTracked.current = false
      isQuarterTracked.current = false
      isMidTracked.current = false
      isThreeQuartersTracked.current = false

      tracking.startMedia(media)
    } else {
      // onResume placeholder
    }
  }

  const togglePlayback = () => {
    const player = playerRef?.current?.audio?.current
    if (player.currentTime > 0 && !player?.paused) {
      player.pause()
    } else {
      player.play()
    }
  }

  return (
    <PlayerWrapper thumbnail={thumbnail} marginTop={5}>
      <PlayOverlayWrapper isPlaying={isPlaying} onClick={togglePlayback}>
        <OverlayBg />
        <img src={playImage} alt="play" />
      </PlayOverlayWrapper>
      <ReactAudioPlayer
        ref={playerRef}
        src={src}
        showJumpControls={false}
        customControlsSection={[RHAP_UI.MAIN_CONTROLS, RHAP_UI.VOLUME_CONTROLS]}
        customProgressBarSection={
          [
            RHAP_UI.PROGRESS_BAR,
            RHAP_UI.CURRENT_TIME,
            <>&nbsp;/&nbsp;</>,
            RHAP_UI.DURATION
          ]
        }
        onListen={onListen}
        autoPlayAfterSrcChange={false}
        layout="horizontal-reverse"
        onPlaying={onStart}
        onPause={() => setIsPlaying(false)} />
    </PlayerWrapper>
  )
}

export default injectIntl(Index)
